<h1 class="text-dark text-xl" mat-dialog-title>
  {{ data.isNew ? 'Nuova Prenotazione Noleggio' : 'Modifica Prenotazione Noleggio' }}
</h1>
<div class="w-full" mat-dialog-content>
  <app-reservation-conflict-banner
    *ngIf="reservationForm"
    [conflicts]="reservationForm.conflicts"
    [upcoming]="reservationForm.upcoming"
  ></app-reservation-conflict-banner>
  <app-rental-reservation-form
    #reservationForm
    (closeDialogEvent)="closeDialog()"
    [data]="data.reservation"
    [isNew]="data.isNew"
    [reloadTrigger$]="data.reloadTrigger$"
  ></app-rental-reservation-form>
</div>
